var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIdreamVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "400px",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7BBB7F2D-5778-4ADE-9A9D-CC19E4E421E2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCF1Screen(1080*1920)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uBC84\\uC804\\uC815\\uBCF4-CHC-APP-SCR-17-01",
    transform: "translate(-340.000000, -715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo/idream_vertical",
    transform: "translate(340.000000, 715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC544\\uC774\\uB4DC\\uB9BC-copy-11",
    transform: "translate(100.000000, 270.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7648054,13.7621744 C28.7648054,6.04869762 23.1246475,0.721404304 14.3824027,0.721404304 C5.64015792,0.721404304 0,6.04869762 0,13.7621744 L0,29.5220838 C0,37.2355606 5.64015792,42.5628539 14.3824027,42.5628539 C23.1246475,42.5628539 28.7648054,37.2355606 28.7648054,29.5220838 L28.7648054,13.7621744 Z M41.9063734,49 L41.9063734,24.1392978 L48.6745629,24.1392978 L48.6745629,16.8142695 L41.9063734,16.8142695 L41.9063734,0 L34.1229554,0 L34.1229554,49 L41.9063734,49 Z M20.9813875,28.6896942 C20.9813875,33.0736127 18.7817259,35.792752 14.3824027,35.792752 C9.98307953,35.792752 7.78341794,33.0736127 7.78341794,28.6896942 L7.78341794,14.594564 C7.78341794,10.2106455 9.98307953,7.49150623 14.3824027,7.49150623 C18.7817259,7.49150623 20.9813875,10.2106455 20.9813875,14.594564 L20.9813875,28.6896942 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6159052,49 L96.6159052,0 L88.8324873,0 L88.8324873,49 L96.6159052,49 Z M82.3463057,13.7621744 C82.3463057,6.04869762 76.536943,0.721404304 67.6818951,0.721404304 C58.8268472,0.721404304 53.0174845,6.04869762 53.0174845,13.7621744 L53.0174845,29.5220838 C53.0174845,37.2355606 58.8268472,42.5628539 67.6818951,42.5628539 C76.536943,42.5628539 82.3463057,37.2355606 82.3463057,29.5220838 L82.3463057,13.7621744 Z M74.5628878,28.6896942 C74.5628878,33.0736127 72.1940214,35.792752 67.6818951,35.792752 C63.1697688,35.792752 60.8009024,33.0736127 60.8009024,28.6896942 L60.8009024,14.594564 C60.8009024,10.2106455 63.1697688,7.49150623 67.6818951,7.49150623 C72.1940214,7.49150623 74.5628878,10.2106455 74.5628878,14.594564 L74.5628878,28.6896942 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.607445,45.7259343 L151.607445,38.9558324 L102.538071,38.9558324 L102.538071,45.7259343 L151.607445,45.7259343 Z M147.602933,29.5220838 L147.602933,22.7519819 L114.890017,22.7519819 L114.890017,8.26840317 L147.038917,8.26840317 L147.038917,1.49830125 L107.106599,1.49830125 L107.106599,29.5220838 L147.602933,29.5220838 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,27.801812 L200,0 L192.216582,0 L192.216582,27.801812 L200,27.801812 Z M200,48.5560589 L200,29.5220838 L161.08291,29.5220838 L161.08291,48.5560589 L200,48.5560589 Z M192.216582,42.0079275 L168.866328,42.0079275 L168.866328,36.0702152 L192.216582,36.0702152 L192.216582,42.0079275 Z M188.776086,26.2480181 L188.776086,19.810872 L164.692611,19.810872 L164.692611,16.7587769 L185.166385,16.7587769 L185.166385,0.943374858 L156.852792,0.943374858 L156.852792,7.38052095 L177.382967,7.38052095 L177.382967,10.4326161 L156.909193,10.4326161 L156.909193,26.2480181 L188.776086,26.2480181 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-3",
    transform: "translate(102.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-36",
    fill: "#37DC8C",
    x: 141.666667,
    y: 111.714286,
    width: 50,
    height: 49.2857143,
    rx: 12.9800307
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-42",
    fill: "#FF375E",
    x: 0,
    y: 111.714286,
    width: 50,
    height: 49.2857143,
    rx: 11.5555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-28",
    fill: "#FFD74B",
    x: 68.3333333,
    y: 62.4285714,
    width: 50,
    height: 98.5714286,
    rx: 12.9800307
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.190476,46 L167.142857,46 C185.289356,46 200,60.7106439 200,78.8571429 L200,98.7342552 C200,105.902928 194.188642,111.714286 187.019969,111.714286 L146.313364,111.714286 C139.144691,111.714286 133.333333,105.902928 133.333333,98.7342552 L133.333333,78.8571429 C133.333333,60.7106439 148.043977,46 166.190476,46 Z",
    id: "Rectangle-Copy-37",
    fill: "#5AA0FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-11",
    fill: "#BDD9FF",
    cx: 166.666667,
    cy: 23,
    rx: 23.3333333,
    ry: 23
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIdreamVertical);
export default __webpack_public_path__ + "static/media/logo_idream_vertical.ee8cc3cb5ba231e5a69c943718207003.svg";
export { ForwardRef as ReactComponent };